module.exports = __webpack_public_path__ + "static/img/vip-info3.b0c69d8a.png";